import * as types from './types';

export const state = {
  faqList: [],
  active: {},
};

export const mutations = {
  [types.SET_FAQ_LIST](state, faqList) {
    state.faqList = faqList;
  },
  [types.SET_ACTIVE_FAQ](state, question) {
    state.active = question;
  },
};



// WEBPACK FOOTER //
// ./src/screens/Faq/store/mutations.js